import React, { FC } from 'react';

import { Heading, Text, VStack } from '@chakra-ui/react';
import ArrowIcon from 'images/icons/arrow-right.svg';

import { Button } from '@/components/atoms/Button';
import { SectionContentWrapper, SectionWrapper } from '@/components/wrappers';
import { DynamicHeroDescriptionFragment } from '@/graphql/generated';
import { GeneralPath } from '@/utils/models';

export const DynamicHeroDescription: FC<DynamicHeroDescriptionFragment> = ({ title, description, buttonCaption }) => {
  return (
    <SectionWrapper>
      <SectionContentWrapper>
        <VStack
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          minH={{
            base: '250px',
            md: '350px',
            lg: '400px',
          }}
          pt={{ base: 0, md: '80px' }}
          pb={{ base: 0, md: '48px' }}
        >
          {description ? (
            <Text
              variant={{
                base: 'text-md/lineHeight-6/font-normal',
                sm: 'text-xl/lineHeight-7/font-normal',
              }}
              textAlign="center"
              color="purple.400"
              maxW={{ base: '95%' }}
            >
              {description}
            </Text>
          ) : null}
          <Heading
            variant={{
              base: 'component-heading-large/xl',
              xs: 'component-heading-large/2xl',
              sm: 'component-heading-large/3xl',
            }}
            as="h1"
            textAlign="center"
            color="purple.500"
            maxW={{
              base: '95%',
              sm: '85%',
              lg: '70%',
            }}
            mt={8}
          >
            {title}
          </Heading>

          {buttonCaption ? (
            <Button
              variant="light"
              label="Let's talk"
              rightIcon={<ArrowIcon width="12px" />}
              mt={{ base: 8 }}
              h="60px"
              w={{ sm: '178px' }}
              url={GeneralPath.CONTACT}
              size="lg"
              borderRadius="100px"
            />
          ) : null}
        </VStack>
      </SectionContentWrapper>
    </SectionWrapper>
  );
};
